
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marca/[slug]",
      function () {
        return require("private-next-pages/marca/[slug].tsx");
      }
    ]);
  